import { render, staticRenderFns } from "./hrd-add-training-center.vue?vue&type=template&id=eb45b140&scoped=true"
import script from "./hrd-add-training-center.vue?vue&type=script&lang=js"
export * from "./hrd-add-training-center.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-training-center.vue?vue&type=style&index=0&id=eb45b140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb45b140",
  null
  
)

export default component.exports